import * as React from 'react'
import * as st from './bannerContainer.module.scss'

export class BannerContainer extends React.Component {
  render() {
    const { children } = this.props
    return <div className={st.bannerContainer}>
      {children}
    </div>
  }
}
